<template>
	<section class="flex md:flex-row flex-col justify-center text-sm px-6 md:px-20 py-4" style="background-color: #F7F7F7;">
		<div class="w-full " style="max-width: 1366px;">
			<Breadclumb :menu="menuBreadclumb"/>
			<h1 class="text-3xl text-spc font-semibold mb-6">Instalação</h1>
			<p class="text-base font-normal text-gray-500 mb-5">
				Antes de realizar o download dos softwares necessários para o uso do seu certificado digital, é de extrema importância a leitura do manual de instalação que contém o passo a passo dos procedimentos necessários para instalação. 
			</p>
			<p class="text-base font-normal text-gray-500 mb-5">

				No arquivo do <a href="/certificacaodigital/suporte/duvidas-frequentes" target="_blank" class="font-semibold text-spc">FAQ</a> você encontrará as respostas às perguntas mais frequentes sobre os Certificados Digitais SPC Brasil.
			</p>
			<p class="text-base font-normal text-gray-500 mb-5">

				Selecione abaixo o tipo do seu Certificado:
			</p>
			<ul class="flex md:flex-row flex-col gap-4 mb-5">
				<li class="instalacao-li grid md:flex flex-col items-center w-full md:w-52 gap-4 p-3 rounded-3xl text-center bg-white box-border">
					<div class="flex md:flex-col flex-row justify-center items-center gap-4">
						<svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M42 4.5H6C3.8 4.5 2 6.3 2 8.5V32.5C2 34.7 3.8 36.5 6 36.5H20V40.5H16V44.5H32V40.5H28V36.5H42C44.2 36.5 46 34.7 46 32.5V8.5C46 6.3 44.2 4.5 42 4.5ZM42 32.5H6V8.5H42V32.5Z" fill="#2966F5"/>
						</svg>
						<h3 class="text-xl text-spc font-bold md:text-center text-left">A1 <br>Sem mídia</h3>
					</div>
					<a class="bg-spc-100 p-3 box-border w-full font-bold text-white rounded-full" href="/certificacaodigital/suporte/instalacao/a1-sem-midia">
						Selecionar
					</a>
				</li>
				<li class="instalacao-li grid md:flex flex-col items-center w-full md:w-52 gap-4 p-3 rounded-3xl text-center bg-white box-border">
					<div class="flex md:flex-col flex-row justify-center items-center gap-4">
						<svg width="107" height="48" viewBox="0 0 107 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M44.2402 8H12.2402C10.0202 8 8.26023 9.78 8.26023 12L8.24023 36C8.24023 38.22 10.0202 40 12.2402 40H44.2402C46.4602 40 48.2402 38.22 48.2402 36V12C48.2402 9.78 46.4602 8 44.2402 8ZM44.2402 36H12.2402V24H44.2402V36ZM44.2402 16H12.2402V12H44.2402V16Z" fill="#2966F5"/>
<path d="M96.0263 20.1609L93.9976 18.1324L100.37 11.7593C100.426 11.7031 100.458 11.6268 100.458 11.5472C100.458 11.4676 100.426 11.3913 100.37 11.335L91.4218 2.39097C91.3046 2.27385 91.1147 2.27388 90.9976 2.39103L84.625 8.76406L82.5802 6.7194C82.463 6.60225 82.2731 6.60226 82.156 6.71942L63.2786 25.5974C63.2786 25.5974 63.2786 25.5974 63.2786 25.5974C62.2446 26.6313 61.6756 28.0095 61.6756 29.4735C61.6756 30.9389 62.2458 32.3159 63.2797 33.3497L63.2797 33.3497L69.4121 39.4804C70.1873 40.2556 71.1672 40.7758 72.2429 40.9835C74.0362 41.3301 75.8767 40.7675 77.165 39.4793L76.9529 39.2671L77.165 39.4793L96.0263 20.6163C96.0912 20.5603 96.1303 20.4779 96.1303 20.3892V20.3881C96.1303 20.2993 96.0912 20.2169 96.0263 20.1609ZM71.4895 37.4031L71.2773 37.6152L71.4895 37.4031L65.3571 31.2724C64.3655 30.2808 64.3655 28.6663 65.3571 27.6747L65.3572 27.6746L82.3681 10.6618L92.0985 20.3892L75.0865 37.402C74.4895 37.9989 73.6352 38.2603 72.801 38.0995C72.3021 38.0031 71.8489 37.7625 71.4895 37.4031ZM96.4262 11.5484L91.919 16.0552L86.7025 10.8402L91.2097 6.33343L96.4262 11.5484Z" fill="#2966F5" stroke="#2966F5" stroke-width="0.6" stroke-linejoin="round"/>
<path d="M93.1248 14.0318L94.8453 12.2935L93.0507 10.4789L91.3291 12.2183L93.1248 14.0318Z" fill="#2966F5"/>
<path d="M90.5579 11.4351L92.2795 9.69683L90.4838 7.8822L88.7622 9.62164L90.5579 11.4351Z" fill="#2966F5"/>
</svg>


						<h3 class="text-xl text-spc font-bold md:text-center text-left">A3 <br>Token ou Cartão</h3>
					</div>

					<a class="bg-spc-100 p-3 box-border w-full font-bold text-white rounded-full" href="/certificacaodigital/suporte/instalacao/a3-token-ou-cartao">
						Selecionar	
					</a>
				</li>
				<li class="instalacao-li grid md:flex flex-col items-center w-full md:w-52 gap-4 p-3 rounded-3xl text-center bg-white box-border">
					<div class="flex md:flex-col flex-row justify-center items-center gap-4">
						<svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M38.7 20.58C37.34 13.68 31.28 8.5 24 8.5C18.22 8.5 13.2 11.78 10.7 16.58C4.68 17.22 0 22.32 0 28.5C0 35.12 5.38 40.5 12 40.5H38C43.52 40.5 48 36.02 48 30.5C48 25.22 43.9 20.94 38.7 20.58ZM38 36.5H12C7.58 36.5 4 32.92 4 28.5C4 24.4 7.06 20.98 11.12 20.56L13.26 20.34L14.26 18.44C16.16 14.78 19.88 12.5 24 12.5C29.24 12.5 33.76 16.22 34.78 21.36L35.38 24.36L38.44 24.58C41.56 24.78 44 27.4 44 30.5C44 33.8 41.3 36.5 38 36.5ZM16 26.5H21.1V32.5H26.9V26.5H32L24 18.5L16 26.5Z" fill="#2966F5"/>
						</svg>

						<h3 class="text-xl text-spc font-bold md:text-center text-left">A3 <br>SPC SafeID</h3>
					</div>


					<a class="bg-spc-100 p-3 box-border w-full font-bold text-white rounded-full" href="/certificacaodigital/suporte/instalacao/a3-safe-id">
						Selecionar	
					</a>
				</li>
			</ul>
			<h2 class="text-2xl font-normal text-gray-600 mb-2">
				Conte com o suporte do SPC Brasil
			</h2>
			<div class="w-full" style="max-width: 600px;">
				<p class="text-base font-normal text-gray-500 mb-5">
					Em caso de dúvidas, acesse nossos canais de atendimento clicando em <a onclick="javascript:window.xgen.maximizeEmbed();" class="text-spc-100 cursor-pointer" target="_blank" >"Olá, Posso ajudar?"</a> 
				</p>
				<p class="text-base font-normal text-gray-500 mb-5">
					Atendimento disponível de segunda a sexta-feira, das 8h às 19h.
				</p>

				<p class="text-base font-normal text-gray-500 mb-5">
					Para facilitar o seu atendimento, <a href="https://anydesk.com/pt/downloads/thank-you?dv=win_exe" class="text-spc-100" target="_blank" >faça o download do Anydesk clicando aqui</a>. Essa ferramenta é necessária para que os nossos especialistas te auxiliem. Após a instalação, abra o Anydesk e informe o número do dispositivo, que será solicitado no atendimento.
				</p>
				
			</div>
		</div>
	</section>
</template>

<script>
import Breadclumb from "@/components/breadclumb/index.vue";
export default {
	data () {
		return {
			menuBreadclumb: [
				{ label: "suporte", href: "/certificacaodigital/suporte"},
				{ label: "instalação", href: "/certificacaodigital/suporte/instalacao"},
			]
		}
	},
	components: {
		Breadclumb
	}
}
</script>

<style>
@media screen and (max-width: 768px) {
	/* li.instalacao-li {
		grid-template-columns: minmax(0,1fr) minmax(0,1fr);
		grid-template-rows: max-content max-content;		
	}
	li.instalacao-li a {
		grid-column: 1 / 3;
	}
	li.instalacao-li svg {
		width: 48px;
	} */
}
</style>
